export enum UserRole {
  STUDENT = 'student',
  TEACHER = 'teacher',
}

export interface TeacherEduProfile {
  role: UserRole.TEACHER
  v: number
}

export interface StudentEduProfile {
  role: UserRole.STUDENT
  v: number
}

export type Profile = {
  school?: StudentEduProfile | TeacherEduProfile
}

export interface Location {
  province: string
  county: string
}
